<eds-panel>
  <div edsGrid>
    <!-- /breadcrumbs  area -->
    <eds-breadcrumbs
      [items]="showBreadcrumb ? detailBreadcrumbs : null"
      theme="basic"
      edsPadding
      edsPaddingLeft="sm"
    >
    </eds-breadcrumbs>
    <ng-container *ngIf="data; else errorHandleTemplate">
      <div class="container--wide" edsPadding edsPaddingTop="lg">
        <!--mobile version-->
        <ng-container *ngIf="isMobile$ | async">
          <div class="literature-item-detail" edsRow>
            <div class="literature-item-detail__content" edsCol>
              <ng-container
                *ngTemplateOutlet="sectionTitleTemplate"
              ></ng-container>

              <div class="literature-item-detail__lit-codes">
                <!--lit document info-->
                <ng-container *ngIf="!data.loginRequired; else loginTemplate">
                  <div class="literature-item-detail__client-use-container">
                    <div class="literature-item-detail__thumbnail">
                      <ng-container
                        *ngTemplateOutlet="imageThumbnailTemplate"
                      ></ng-container>
                    </div>
                    <ng-container
                      *ngTemplateOutlet="clientUseTemplate"
                    ></ng-container>
                  </div>
                  <div class="literature-item-detail__buttons">
                    <ng-container
                      *ngTemplateOutlet="buttonsTemplate"
                    ></ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

        <!--tablet-->
        <ng-container *ngIf="isTablet$ | async">
          <div class="literature-item-detail" edsRow>
            <div class="literature-item-detail__content" edsCol>
              <ng-container
                *ngTemplateOutlet="sectionTitleTemplate"
              ></ng-container>

              <div
                class="literature-item-detail__lit-codes"
                edsFlexbox
                [justifyContent]="'flex-start'"
              >
                <!--thumbnail-->
                <div class="literature-item-detail__thumbnail">
                  <ng-container
                    *ngTemplateOutlet="imageThumbnailTemplate"
                  ></ng-container>
                </div>

                <!--lit document info-->
                <div class="literature-item-detail__client-use-container">
                  <ng-container *ngIf="!data.loginRequired; else loginTemplate">
                    <ng-container
                      *ngTemplateOutlet="clientUseTemplate"
                    ></ng-container>
                    <div class="literature-item-detail__buttons">
                      <ng-container
                        *ngTemplateOutlet="buttonsTemplate"
                      ></ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!--desktop version-->
        <ng-container *ngIf="(isHandheld$ | async) !== true">
          <div class="literature-item-detail" edsFlexbox>
            <!--thumbnail-->
            <div
              class="literature-item-detail__thumbnail"
              edsFlexbox
              [alignItems]="(isHandheld$ | async) !== true ? '' : 'left'"
              [justifyContent]="!data.isWidenData ? 'left' : ''"
            >
              <ng-container
                *ngTemplateOutlet="imageThumbnailTemplate"
              ></ng-container>
            </div>
            <!--lit document info-->
            <div class="literature-item-detail__content">
              <ng-container
                *ngTemplateOutlet="sectionTitleTemplate"
              ></ng-container>
              <ng-container *ngIf="!data.loginRequired; else loginTemplate">
                <div class="literature-item-detail__client-use-container">
                  <ng-container
                    *ngTemplateOutlet="clientUseTemplate"
                  ></ng-container>
                  <div class="literature-item-detail__buttons">
                    <ng-container
                      *ngTemplateOutlet="buttonsTemplate"
                    ></ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- end item-detail-->
    </ng-container>

    <!--TODO place complimentry component here with some condition-->
    <!-- <literature-complimentry-details></literature-complimentry-details> -->
  </div>
</eds-panel>
<ng-template #downloadNotAvailble>
  <div>
    {{ "literature.cart-download-unavailable-alert-body-msg" | translate }}
  </div>
</ng-template>

<ng-template #sectionTitleTemplate>
  <eds-section-title
    theme="basic"
    [preTitle]="data.publicationDate"
    [subTitle]="data.dctermsDescription"
    [title]="data.fundName"
    edsSpacing="lg"
  ></eds-section-title>
</ng-template>

<ng-template #clientUseTemplate>
  <!--client use-->
  <div class="literature-item-detail__client-use">
    <div *ngIf="data.clientUse">
      <eds-info-item *ngFor="let item of infoData" [info]="item">
        <span edsFlexbox [flexDirection]="'row'" justifyContent="flex-end"
          >{{ item.value }}
          <span
            edsFlexbox
            [alignItems]="'baseline'"
            *ngIf="item.link && data.href"
            edsPadding
            edsPaddingLeft="xs"
            >(<eds-link-item
              [title]="item.link"
              (click)="goToLink(data, 'finra', $event)"
              [noPadding]="true"
            ></eds-link-item
            >)</span
          >
        </span>
      </eds-info-item>
    </div>
  </div>
</ng-template>

<ng-template #buttonsTemplate>
  <!--buttons-->
  <div
    edsFlexbox
    flexDirection="row"
    flexWrap="wrap"
    alignItems="center"
    edsPadding
    edsPaddingTop="xl"
    [edsSpacing]="(isHandheld$ | async) !== true ? 'xs' : 'lg'"
  >
    <div
      [edsSpacing]="(isHandheld$ | async) !== true ? 'md' : 'sm'"
      edsPadding
      [edsPaddingRight]="(isHandheld$ | async) !== true ? 'sm' : 'xs'"
    >
      <ng-container *ngIf="isShowDownloadBtn; else downloadNotAvailble">
        <button
          edsButton="primary"
          size="normal"
          data-analytics-no-event="true"
          [hasIcon]="true"
          (click)="goToLink(data, 'pdf', $event)"
          [noMargin]="true"
          [disabled]="data.isRestrictedActor"
        >
          <span *ngIf="data.fileExtension === 'pdf'" class="ft__btn__txt">{{
            "literature.lit-listing-download-pdf" | translate
          }}</span>
          <span *ngIf="data.fileExtension !== 'pdf'" class="ft__btn__txt">{{
            "literature.download" | translate
          }}</span>
          <eds-icon type="download" size="small"></eds-icon>
        </button>
      </ng-container>
      <ng-template #downloadNotAvailble>
        <div>
          {{
            "literature.cart-download-unavailable-alert-body-msg" | translate
          }}
        </div>
      </ng-template>
    </div>
    <div
      [edsSpacing]="(isHandheld$ | async) !== true ? 'md' : 'sm'"
      edsPadding
      [edsPaddingRight]="(isHandheld$ | async) !== true ? 'sm' : 'xs'"
    >
      <button
        *ngIf="isCartConfigured"
        [edsButton]="addedInCart ? 'primary' : 'secondary'"
        [ngClass]="addedInCart ? 'paddingButton' : ''"
        size="normal"
        [noMargin]="true"
        [disabled]="addedInCart || data.isRestrictedActor"
        (click)="addToCartHandler(data, $event)"
      >
        <span class="ft__btn__txt" *ngIf="addedInCart">{{
          "literature.added" | translate
        }}</span>
        <span class="ft__btn__txt" *ngIf="!addedInCart">{{
          "literature.Add-to-cart" | translate
        }}</span>
        <eds-icon
          type="cart"
          size="small"
          edsPadding
          edsPaddingLeft="xs"
        ></eds-icon>
      </button>
    </div>
    <div
      *ngIf="literatureContentDocument"
      [edsSpacing]="(isHandheld$ | async) !== true ? 'md' : 'sm'"
    >
      <button
        edsButton="tertiary"
        size="normal"
        [noMargin]="true"
        (click)="openAnAccountHandler(data, $event)"
      >
        <span class="ft__btn__txt">{{
          "literature.open-account" | translate
        }}</span>
      </button>
    </div>
  </div>
  <!--notifications-->
  <eds-notifications
    edsSpacing="none"
    [hasIcon]="true"
    *ngIf="data?.hardCopyNotAvailable && isCartConfigured"
    title="{{ 'literature.cart-hardcopy-alert-body-msg' | translate }}"
    [inline]="true"
    notificationType="warning"
    [small]="true"
  >
  </eds-notifications>
  <eds-notifications
    edsSpacing="none"
    [hasIcon]="true"
    *ngIf="data.isRestrictedActor"
    title="{{ 'literature.lit-detail-cross-audience-message' | translate }}"
    [inline]="true"
    notificationType="warning"
    [small]="true"
  >
  </eds-notifications>
</ng-template>

<ng-template #imageThumbnailTemplate>
  <div *ngIf="data.isWidenData" edsPadding edsPaddingRight="md">
    <button
      *ngIf="isShowDownloadBtn; else downloadNotAvailble"
      class="literature-item-detail__thumbnail-image"
      data-analytics-no-event="true"
      (click)="goToLink(data, 'pdf', $event)"
      [disabled]="data.loginRequired || data.isRestrictedActor"
    >
      <span *ngIf="data.fileExtension === 'pdf'" class="sr-only">{{
        "literature.lit-listing-download-pdf" | translate
      }}</span>
      <span *ngIf="data.fileExtension !== 'pdf'" class="sr-only">{{
        "literature.download" | translate
      }}</span>
      <div class="literature-item-detail__thumbnail-image-size">
        <eds-image [imgSrc]="data.imageUrl" alt=""></eds-image>
      </div>
    </button>
  </div>
</ng-template>

<ft-literature-dialog
  [modalIdEnum]="'cartModal'"
  [dialogId]="'cartModal'"
  [gridData]="dialogData"
  (dialog)="closeDialog($event)"
  (deleteCartDoc)="updateStorage($event)"
  (modalClose)="closeDialog('cartModal')"
></ft-literature-dialog>

<ng-template #errorHandleTemplate>
  <ng-container *ngIf="dataLoaded">
    <div edsGrid>
      <div class="container--wide">
        <p edsPadding edsPaddingAll="lg">
          {{ "literature.lit-detail-page-no-content" | translate }}
        </p>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #loginTemplate>
  <div edsGrid>
    <ft-sign-in
      [inputParameters]="{
        skin: 'Basic',
        legacy: false,
        signOut: false
      }"
    >
    </ft-sign-in>
  </div>
</ng-template>
